// import React from 'react';
// import { Search, ShoppingCart, User } from 'lucide-react';
// import { useNavigate } from 'react-router-dom';

// const Header = ({ searchQuery, setSearchQuery }) => {
//   const navigate = useNavigate();

//   return (
//     <header className="bg-surface border-b border-border sticky top-0 z-50 shadow-sm">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
//         {/* Top Bar */}
//         <div className="flex items-center justify-between mb-4">
//           {/* Logo */}
//           <div className="flex items-center gap-3">
//             <div className="w-10 h-10 rounded-full flex items-center justify-center">
//               <span className="text-2xl">          <img
//             src={'https://mpxasset.s3.ap-southeast-3.amazonaws.com/apps/logo-icon.png'}
//             alt={'logo'}
//             className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
//           /></span>
//             </div>
//             <div>
//               <h1 className="text-xl font-bold text-primary">UMKM Bangkalan</h1>
//               <p className="text-xs text-muted-foreground hidden sm:block">Belanja dari warung terdekat</p>
//             </div>
//           </div>

//           {/* Actions */}
//           <div className="flex items-center gap-3">
//             <button className="p-2 hover:bg-muted rounded-lg transition-colors">
//               <User className="w-5 h-5 text-muted-foreground" />
//             </button>
//             <button className="relative p-2 hover:bg-muted rounded-lg transition-colors">
//               <ShoppingCart className="w-5 h-5 text-muted-foreground" />
//               <span className="absolute -top-1 -right-1 w-5 h-5 bg-secondary text-white text-xs rounded-full flex items-center justify-center font-semibold">
//                 0
//               </span>
//             </button>
//           </div>
//         </div>

//         {/* Search Bar */}
//         <div className="relative">
//           <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-muted-foreground" />
//           <input
//             type="text"
//             placeholder="Cari kebutuhan harianmu... (beras, minyak, telur)"
//             value={searchQuery}
//             onChange={(e) => setSearchQuery(e.target.value)}
//             className="w-full pl-12 pr-4 py-3 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-all text-sm"
//           />
//         </div>
//       </div>
//     </header>
//   );
// };

// export default Header;

import React from 'react';
import { Search, ShoppingCart, User } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const Header = ({ searchQuery, setSearchQuery }) => {
  const navigate = useNavigate();

  return (
    <header className="bg-surface border-b border-border sticky top-0 z-50 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        {/* Top Bar */}
        <div className="flex items-center justify-between mb-4">
          {/* Logo */}
          <div className="flex items-center gap-2 sm:gap-3">
            <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-full flex items-center justify-center">
              <span className="text-2xl">          <img
              src={'https://mpxasset.s3.ap-southeast-3.amazonaws.com/apps/logo-icon.png'}
              alt={'logo'}
              className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
             /></span> 
            </div>
            <div>
              <h1 className="text-base sm:text-xl font-bold text-primary">UMKM Bangkalan</h1>
              <p className="text-xs text-muted-foreground hidden sm:block">Belanja dari warung terdekat</p>
            </div>
          </div>

          {/* Actions */}
          <div className="flex items-center gap-3">
            <button className="p-2 hover:bg-muted rounded-lg transition-colors">
              <User className="w-5 h-5 text-muted-foreground" />
            </button>
            <button className="relative p-2 hover:bg-muted rounded-lg transition-colors">
              <ShoppingCart className="w-5 h-5 text-muted-foreground" />
              <span className="absolute -top-1 -right-1 w-5 h-5 bg-secondary text-white text-xs rounded-full flex items-center justify-center font-semibold">
                0
              </span>
            </button>
          </div>
        </div>

        {/* Search Bar */}
        <div className="relative">
          <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-muted-foreground" />
          <input
            type="text"
            placeholder="Cari kebutuhan harianmu... (beras, minyak, telur)"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-full pl-12 pr-4 py-3 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-primary/20 focus:border-primary transition-all text-sm"
          />
        </div>
      </div>
    </header>
  );
};

export default Header;
